import React from "react";
import { css, Theme, useTheme } from "@emotion/react";
import dayjs from "dayjs";

import DatePeriod from "core/Components/Item/DatePeriod";
import { getTwelveHourTime } from "core/includes/dates";

type Props = {
    data: EventPage,
    title: string,
    labelColour: string,
};

const LabelBox: React.FC<Props> = ({ data, title, labelColour }) => {
    const theme: Theme = useTheme();

    const getValue = () => {
        switch (title) {
            case 'Location':
                return data.cityCode.name;
            case 'Date':
                return <DatePeriod start={data.eventDate} end={data.eventEndDate} />;
            default:
                return getTwelveHourTime(data.eventStartTime) +
                    '-' + getTwelveHourTime(data.eventEndTime, true) +
                    ' ' + (!!dayjs(data.eventDate).diff(dayjs(data.eventEndDate)) && ' both days');
        }
    };

    const style = css`
        display: flex;
        margin-bottom: 16px;
        font-weight: ${theme.fonts.weights.bold};
    `;

    const labelStyle = css`
        width: 100px;
        
        ${labelColour && css`
            color: ${labelColour};
        `} 
    `;

    return (
        <div css={style}>
            <span css={labelStyle}>{title}:</span>
            <span>{getValue()}</span>
        </div>
    );
};

export default LabelBox;